import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Loader2 } from "lucide-react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "@/components/ui/alert-dialog";
import { api } from "@/lib/api";
import { useLang, errorText } from "@/lib/i18n";

export const DeleteEmployeesDialog = ({ people, onClose, onDeleted }) => {
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  const open = people.length > 0;
  const run = async () => {
    setBusy(true);
    try {
      if (people.length === 1) await api.delete(`/employees/${people[0].id}`);
      else await api.post("/employees/bulk-delete", { ids: people.map((p) => p.id) });
      toast.success(`${people.length} ${t("emp.deletedToast")}`);
      onDeleted();
    } catch (e) {
      toast.error(errorText(t, e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent className="rounded-none" data-testid="delete-employees-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl">{people.length === 1 ? t("emp.deleteOne") : `${t("emp.deleteMany")} (${people.length})`}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm">
              <p data-testid="delete-employees-names" className="font-medium text-neutral-700">{people.map((p) => p.name).join(", ")}</p>
              <p>{t("emp.deleteWarn")}</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-employees-cancel" disabled={busy} className="rounded-full">{t("c.cancel")}</AlertDialogCancel>
          <button data-testid="delete-employees-confirm" disabled={busy} onClick={run} className="press h-10 px-5 rounded-full bg-red-600 text-white text-sm font-semibold flex items-center justify-center gap-2 hover:bg-red-500 disabled:opacity-50">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}{t("emp.deleteConfirm")}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
